export const SENSORTYPE_CHARGE = 'BAT';
export const BOXMODEL_PRO = 'PRO';
export const SUPPORT_PHONE_NUMBER = '+380 96 846 59 45';

export const DEVICE_STATUS = {
  get TEMPORARY_DISABLED_DEVICE_STATUS() {
    return 'TEMPORARY_SHUTDOWN';
  },
  get ACTIVE() {
    return 'ACTIVE';
  },
  get ARCHIVE() {
    return 'ARCHIVE';
  },
};

export const NOTIFICATIONS_TYPE = {
  get EVENT_DURATION() {
    return 'aa6f5c2c-6cb4-4445-8c91-23013b5e6d3c';
  },
  get TARGET_VALUE() {
    return '5a7b31c0-8ce8-4ba6-826a-1c8ed07f3872';
  },
  get WORK_IN_NON_WORK_TIME() {
    return 'db9d9041-a853-4856-814a-0a6e550f0d9d';
  },
  get BATTERY_LOW() {
    return 'f07be85f-9e05-4c0f-b582-b6e7ff0f14ef';
  },
  get DE_PHASING() {
    return 'f56c3ff2-8063-4822-9991-07af6f9c25f4';
  },
  get DEVICE_OFF() {
    return 'a551b7c7-9406-49ee-a86f-d2bacd44664a';
  },
};

export const REPORT_TIME_TYPE = {
  get DAY() {
    return 'DAY';
  },
  get WEEK() {
    return 'WEEK';
  },
  get MONTH() {
    return 'MONTH';
  },
  get PERIOD() {
    return 'PERIOD';
  },
};

export const REPORT_TYPE = {
  get EFFICIENCY() {
    return 'efficiency';
  },
  get DOWNTIME() {
    return 'downtime';
  },
};
export const SENSOR_ID = {
  get VALUE() {
    return 'VALUE';
  },
  get BATTERY() {
    return 'BATTERY';
  },
  get SIGNAL() {
    return 'SIGNAL';
  },
  get AVG() {
    return 'AVG';
  },
};

export const AR_SENSOR = {
  get TEMPERATURE() {
    return 'STMP';
  },
  get VIBRATION() {
    return 'VIBR';
  },
  get PRESSURE() {
    return 'SPRES';
  },
  get BUTTON_PRESS() {
    return 'BTNPRS';
  },
};

export const SENSOR_UNITS = {
  get TEMPERATURE() {
    return `\u2103`;
  },
  get VIBRATION() {
    return 'Hz';
  },
  get PRESSURE() {
    return 'Pa';
  },
};
